import { apiSlice } from '../../api/apiSlice';
import {
    ActivityLogsListParams,
    ActivityLogsListResponse,
} from './activityLogsListApiSliceTypes';

const activityLogsListApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getActivityLogsList: builder.query<
            ActivityLogsListResponse,
            ActivityLogsListParams
        >({
            query: (params) => {
                const { page = 1, limit = 10, ...queryParams } = params ?? {};

                return {
                    url: '/activity-logs',
                    method: 'GET',
                    headers: {
                        'Accept-Language': params.acceptLanguage ?? 'en',
                    },
                    params: {
                        page,
                        limit,
                        ...queryParams,
                    },
                };
            },

            providesTags: () => [{ type: 'plans', id: 'LIST' }],
        }),
    }),
    overrideExisting: true,
});

export const { useGetActivityLogsListQuery, useLazyGetActivityLogsListQuery } =
    activityLogsListApiSlice;
